<template>
  <div>
    <div class="text-subtitle-2 pa-1 blue--text blue lighten-5 mb-2">
      「新人」「PickUp」をクリックして、キャストの属性を指定します。
    </div>
    <v-container fluid>
      <v-row justify="space-between">
        <v-col cols="6" sm="3">
          <general-button btn_type="info" btn_block @click-event="onSubmit"
            ><template v-slot:icon
              ><v-icon left>mdi-content-save</v-icon></template
            >保存</general-button
          >
        </v-col>
        <v-col cols="6">
          <div>
            <v-text-field
              v-model="castSearch"
              append-icon="mdi-magnify"
              label="（セラピスト名検索）"
              single-line
              hide-details
              clearable
              dense
              class="mb-2"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      id="cast_table"
      :headers="castHeaders"
      :items="casts"
      :search="castSearch"
      item-key="id"
      :mobile-breakpoint="0"
      :items-per-page="-1"
      :footer-props="{
        'items-per-page-options': [50, 100, -1],
        'items-per-page-text': '表示件数',
      }"
    >
      <!-- eslint-disable-next-line -->
            <template v-slot:footer.page-text="props">
        {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
          props.itemsLength
        }}件
      </template>
      <!-- 画像 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.image="{ item }">
        <v-avatar class="ma-1"
          ><v-img :src="setting.cdn + item.image"
        /></v-avatar>
      </template>
      <!-- 名前 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <!-- 公開 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.enable="{ item }">
        <div class="pa-1">
          <v-chip
            v-if="item.is_enable"
            class="ma-2"
            color="primary"
            label
            small
          >
            公開中
          </v-chip>
          <v-chip v-else class="ma-2" label small> 非公開 </v-chip>
        </div>
      </template>
      <!-- 新人 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.newcast_flg="{ item }">
        <div class="pa-1 text-center">
          <div
            :class="`pa-1 cursor-pointer font-bold text-white rounded-lg ${
              item.newcast_flg ? 'bk-green' : 'bk-light-gray'
            }`"
            style="max-width: 80px"
            @click="newcastFlgClick(item.id)"
          >
            新人
          </div>
        </div>
      </template>
      <!-- ピックアップ -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.pickup_flg="{ item }">
        <div class="pa-1 text-center">
          <div
            :class="`pa-1 cursor-pointer font-bold text-white rounded-lg ${
              item.pickup_flg ? 'bk-orange' : 'bk-light-gray'
            }`"
            style="max-width: 80px"
            @click="pickupFlgClick(item.id)"
          >
            PickUp
          </div>
        </div>
      </template>
      <template v-slot:item.profile="{ item }">
        <span class="profile_span"
          >{{ item.profile_1 }}<br />{{ item.profile_2 }}</span
        >
      </template>
      <template v-slot:no-data> セラピストが登録されていません </template>
    </v-data-table>
    <v-container fluid>
      <v-row justify="start">
        <v-col cols="6" sm="3">
          <general-button btn_type="info" btn_block @click-event="onSubmit"
            ><template v-slot:icon
              ><v-icon left>mdi-content-save</v-icon></template
            >保存</general-button
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import utilDate from "@/common/utilDate.js";

export default defineComponent({
  props: ["shop_site_id"],
  setup(props, ctx) {
    const ShopSitePickupsRepository = repositoryFactory.get("shopSitePickups");
    const ShopSiteNewcastsRepository =
      repositoryFactory.get("shopSiteNewcasts");
    const CastsRepository = repositoryFactory.get("casts");

    const state = reactive({
      // キャスト
      casts: [],
      castSearch: "",
      castSelected: [],
      castHeaders: [
        {
          text: "画像",
          value: "image",
          sortable: false,
          align: "center",
          class: "td_image",
          width: 80,
        },
        {
          text: "セラピスト名",
          value: "name",
          sortable: true,
          class: "td_name",
        },
        { text: "公開/非公開", value: "enable", sortable: true, width: 110 },
        {
          text: "プロフィール",
          value: "profile",
          sortable: false,
          class: "td_profile",
          width: 120,
        },
        {
          text: "入店日",
          value: "entry_date",
          sortable: true,
          class: "td_entry_date",
          width: 120,
        },
        {
          text: "新人設定",
          value: "newcast_flg",
          sortable: true,
          class: "td_newcast_flg",
          width: 120,
        },
        {
          text: "ピックアップ設定",
          value: "pickup_flg",
          sortable: true,
          class: "td_pickup_flg",
        },
      ],
    });

    onMounted(async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // セラピストデータ取得
      const currentShop = store.getters["shops/currentShop"];

      // パラメータセット
      let params = new URLSearchParams();
      state.casts.splice(0);
      params.append("shop_id", currentShop.id);
      await CastsRepository.list_profile(params)
        .then((response) => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              const common_shop_site = [];
              for (let j = 0; j < response.data[i].prop.length; j++) {
                common_shop_site.push(response.data[i].prop[j]);
              }
              const p_age = common_shop_site.find(
                (r) => r.key == "cast__basic__age"
              );
              const p_tall = common_shop_site.find(
                (r) => r.key == "cast__basic__tall"
              );
              const text_age =
                "年齢:" + (!p_age ? "__" : p_age["value"] ?? "__");
              const text_tall =
                " 身長:" + (!p_tall ? "__" : p_tall["value"] ?? "__");
              const profile_1 = text_age + text_tall;
              const p_bust = common_shop_site.find(
                (r) => r.key == "cast__basic__bust"
              );
              const p_cup = common_shop_site.find(
                (r) => r.key == "cast__basic__cup"
              );
              const p_waist = common_shop_site.find(
                (r) => r.key == "cast__basic__waist"
              );
              const p_hip = common_shop_site.find(
                (r) => r.key == "cast__basic__hip"
              );
              const text_bust =
                "B:" + (!p_bust ? "__" : p_bust["value"] ?? "__");
              const text_cup =
                "(" +
                (!p_cup || p_cup == null ? "__" : p_cup["value"] ?? "__") +
                ")";
              const text_waist =
                " W:" + (!p_waist ? "__" : p_waist["value"] ?? "__");
              const text_hip = " H:" + (!p_hip ? "__" : p_hip["value"] ?? "__");
              const profile_2 = text_bust + text_cup + text_waist + text_hip;
              const tmpCast = response.data[i];
              tmpCast.profile_1 = profile_1;
              tmpCast.profile_2 = profile_2;

              const p_entry_date = common_shop_site.find(
                (r) => r.key == "cast__basic__entry_date"
              );
              let entry_date = "";
              if (p_entry_date && p_entry_date["value"]) {
                entry_date = utilDate.convertStrToFormatFull(
                  p_entry_date["value"]
                );
              }
              tmpCast.entry_date = entry_date;

              tmpCast.newcast_flg = false;
              tmpCast.pickup_flg = false;

              state.casts.push(tmpCast);
            }
          }
        })
        .catch((error) => {
          throw "ERROR:CastsRepository.list (" + error + ")";
        });

      // ピックアップキャスト取得
      const pickupCasts = await ShopSitePickupsRepository.list_shopsite(
        props.shop_site_id
      )
        .then((response) => {
          if (response.data) {
            return response.data.map((item) =>
              state.casts.find((cast) => cast.id == item.cast_id)
            );
          } else {
            return [];
          }
        })
        .catch((error) => {
          throw "ERROR:ShopSitePickupsRepository.get (" + error + ")";
        });
      state.casts.forEach((cast) => {
        const isPickup = pickupCasts.some((p) => p.id === cast.id);
        cast.pickup_flg = isPickup;
      });

      // 新人キャスト取得
      const newcasts = await ShopSiteNewcastsRepository.list_shopsite(
        props.shop_site_id
      )
        .then((response) => {
          if (response.data) {
            return response.data.map((item) =>
              state.casts.find((cast) => cast.id == item.cast_id)
            );
          } else {
            return [];
          }
        })
        .catch((error) => {
          throw "ERROR:ShopSiteNewcastsRepository.get (" + error + ")";
        });
      state.casts.forEach((cast) => {
        const isNewcast = newcasts.some((p) => p.id === cast.id);
        cast.newcast_flg = isNewcast;
      });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    });

    const onSubmit = async () => {
      // ピックアップキャスト登録
      if (!window.confirm("保存してよろしいですか？")) {
        return false;
      }

      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const pickupList = state.casts
        .filter((cast) => cast.pickup_flg)
        .map((cast) => cast.id);
      let params = {
        shop_site_id: props.shop_site_id,
        pickup_list: pickupList,
      };
      await ShopSitePickupsRepository.save_list(params)
        .then((response) => {
          if (response.data) {
            // 保存OK
          }
        })
        .catch((error) => {
          throw "ERROR:ShopSitePickupsRepository.save_list (" + error + ")";
        });

      const newcastList = state.casts
        .filter((cast) => cast.newcast_flg)
        .map((cast) => cast.id);
      params = {
        shop_site_id: props.shop_site_id,
        newcast_list: newcastList,
      };
      await ShopSiteNewcastsRepository.save_list(params)
        .then((response) => {
          if (response.data) {
            // 保存OK
          }
        })
        .catch((error) => {
          throw "ERROR:ShopSiteNewcastsRepository.save_list (" + error + ")";
        });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    const newcastFlgClick = async (cast_id) => {
      const targetCast = state.casts.find((cast) => cast.id === cast_id);
      if (targetCast) {
        targetCast.newcast_flg = !targetCast.newcast_flg;
      }
    };

    const pickupFlgClick = async (cast_id) => {
      const targetCast = state.casts.find((cast) => cast.id === cast_id);
      if (targetCast) {
        targetCast.pickup_flg = !targetCast.pickup_flg;
      }
    };

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      onSubmit,
      newcastFlgClick,
      pickupFlgClick,
    };
  },
});
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
::v-deep .mini label {
  font-size: 0.75em;
}

::v-deep .td_name {
  min-width: 100px;
  width: 200px;
}
::v-deep .td_profile,
::v-deep .td_entry_date,
::v-deep .td_newcast_flg,
::v-deep .td_pickup_flg {
  min-width: 120px;
}
.profile_span {
  font-size: 0.75em;
}
::v-deep .td_shop_site {
  min-width: 200px;
}
.shop_site_span {
  font-size: 0.75em;
  background-color: #fafafa;
  word-break: break-all;
}
</style>
